import {
    Button,
    createButton,
} from '@vfde-brix/ws10/button';
import { Overlay } from '@vfde-brix/ws10/overlay';
import {
    GIGAKOMBI_OVERLAY_GIGAKOMBI_BUTTON_ID,
    GIGAKOMBI_OVERLAY_NO_GIGAKOMBI_BUTTON_ID,
} from '../../../app/constants';
import { useAppDispatch } from '../../../app/store';
import { goToBasket } from '../slice';

/**
 * Mount Gigakombi Overlay Buttons
 */
export const mountGigakombiOverlayButtons = (overlay: Overlay): [
    Button | null,
    Button | null,
] => {
    const contentContainer = overlay.getOverlayContentContainer();

    const gkButton = contentContainer.querySelector(`#${GIGAKOMBI_OVERLAY_GIGAKOMBI_BUTTON_ID}`);
    const noGkButton = contentContainer.querySelector(`#${GIGAKOMBI_OVERLAY_NO_GIGAKOMBI_BUTTON_ID}`);

    const dispatch = useAppDispatch();

    const confirmGigaKombiButton = gkButton && createButton(gkButton, {
        onClick: () => {
            dispatch(goToBasket(true));
            overlay.close();
        },
    });

    const disableGigakombiButton = noGkButton && createButton(noGkButton, {
        onClick: () => {
            dispatch(goToBasket(false));
            overlay.close();
        },
    });

    return [
        confirmGigaKombiButton,
        disableGigakombiButton,
    ];
};
